import { render } from "./our_services.vue?vue&type=template&id=02faf647&scoped=true"
import script from "./our_services.vue?vue&type=script&lang=js"
export * from "./our_services.vue?vue&type=script&lang=js"

import "./our_services.vue?vue&type=style&index=0&id=02faf647&scoped=true&lang=css"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02faf647"]])

export default __exports__